import React from 'react';
import './Bjservice.css'; 
import BJSeries from '../../../imgs/BJ-Series.webp';
import KIISeries from '../../../imgs/KII-Series.webp';

function Bjservice() {
  return (
    <div className="bj-container">
      <h2 className="heading"></h2>
      <div className="card-wrapper">
        <div className="card-Bjeservise" data-aos="flip-left">
          <img
            src={BJSeries}
            alt="BJ Series"
            className="card-image"
          />
          <p className="card-servis">BJ Series- Energy-Saving Injection Molding Machine</p>
        </div>
        <div className="card-Bjeservise" data-aos="flip-right">
          <img
            src={KIISeries}
            alt="KII Series"
            className="card-image"
          />
          <p className="card-servis">KII Series- High Precision Injection Molding Machine</p>
        </div>
      </div>
    </div>
  );
}

export default Bjservice;
